import { Button } from '@/components/shared/button/Button';
import { TSTitleCard } from '@/components/shared/card/Card';
import { dateToDateOnlyApiFormat } from '@/helpers/dateHelper';
import { useUpcomingLeaveListItems } from '@/services/leaveManagement/useUpcomingLeaveListItems';
import { FC } from 'react';
import { AiOutlineCalendar } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import essStrings from '../../../ess.translations';
import { MyScheduleLeaveBalanceSummary } from './MyScheduleLeaveBalanceSummary';
import { MyScheduleLeaveRequestList } from './MyScheduleLeaveRequestList';

const MAX_ITEMS = 3;

export const MyScheduleUpcomingLeaveCard: FC<{ userId: string }> = ({ userId }) => {
  const { items: upcomingItems } = useUpcomingLeaveListItems(userId);

  const hasMore = upcomingItems.length > MAX_ITEMS;
  const items = upcomingItems.slice(0, MAX_ITEMS);

  const navigate = useNavigate();

  const onAddBooking = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    navigate(`/ess/my-calendar/my-leave?startDate=${dateToDateOnlyApiFormat(tomorrow)}`);
  };

  return (
    <TSTitleCard
      title={essStrings.mySchedule.leave.cardTitle}
      icon={AiOutlineCalendar}
      secondaryAction={{
        label: essStrings.mySchedule.leave.addBooking,
        onClick: onAddBooking
      }}
    >
      <p className="font-semibold mb-4">{essStrings.mySchedule.leave.leaveBalances}</p>
      <MyScheduleLeaveBalanceSummary userId={userId} />

      <p className="font-semibold mb-4">{essStrings.mySchedule.leave.upcomingLeave}</p>
      {items.length === 0 ? (
        <p className="py-4 text-center text-gray-500">{essStrings.mySchedule.leave.noLeave}</p>
      ) : (
        <>
          <MyScheduleLeaveRequestList items={items} />
          {hasMore && (
            <Button className="w-full mt-5" onClick={() => navigate('upcoming-leave')}>
              {essStrings.common.showAll}
            </Button>
          )}
        </>
      )}
    </TSTitleCard>
  );
};
